import { render } from "./EditPermissionInfo.vue?vue&type=template&id=3d8c55c5&scoped=true"
import script from "./EditPermissionInfo.vue?vue&type=script&lang=js"
export * from "./EditPermissionInfo.vue?vue&type=script&lang=js"

import "./EditPermissionInfo.vue?vue&type=style&index=0&id=3d8c55c5&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8c55c5"]])

export default __exports__